import { useIntersectionObserver as inner } from "usehooks-ts";

// Use trickery to make it seem (to the vite unbarrel plugin) that this library is the source of this hook:
// this allows us to reference hooks without having to import the usehooks-ts library into teach/home/etc:
export const useIntersectionObserver = inner;
